import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { TextField, Button, Collapse } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { withRouter, Link } from 'react-router-dom';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as IssueActions from "../actions/IssueActions";
import * as UserActions from "../actions/UserActions";

const useStyles = makeStyles(() => ({
  root: {
		display: "flex",
		alignItems: "center",
		//height: "80vh",
		justifyContent: "center",
		flexDirection: "column"
  },
	formControl: {
    minWidth: 350,
		display: "flex",
		flexDirection: "column"
  },
}));

const Login = (props) => {
	//console.log("[Login.js] ", props);
	const classes = useStyles();

	const [open, setOpen] = useState(true);

	const [data, setData] = useState({
		id: "",
		password: ""
	});

	const handleChange = (event) => {
		setData({...data, [event.target.name]: event.target.value});
	}

	const onSubmit = async (event) => {
		setOpen(true);
		event.preventDefault();
		console.log(props);
		props.userActions.loginUser(data);
	}

	return (
		<div className={classes.root}>
			<form onSubmit={onSubmit} className={classes.formControl}>
				<TextField 
					id="email" 
					label="Email" 
					type="email" 
					name="id"
					value={data["id"]} 
					onChange={handleChange}
					required
				/>
				<br></br>
				<TextField 
					id="password" 
					label="Password" 
					type="password" 
					name="password"
					value={data["password"]} 
					onChange={handleChange}
					required
				/>
				<br></br>
				{
					props.users.error
						? (<><Collapse in={open}>
								<Alert 
									severity="error" 
									onClose={() => {setOpen(false)}}
								>
									{props.users.error}
								</Alert>
							</Collapse><br></br></>)
						: null
				}
				<Button type="submit" variant="contained" color="primary">
					Login
				</Button>
			</form>
			<p>Don't have an account? <Link to="/issue-tracker/signup">Signup here</Link></p>
		</div>
	)
}

function mapStateToProps(state) {
	return {
	  issues: state.issues,
		users: state.users
	};
  }
  
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(IssueActions, dispatch),
		userActions: bindActionCreators(UserActions, dispatch)
	};
}
  
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login));
